/* =====================================================================
   UUGI Events Page — Interactions
   ===================================================================== */

$(function () {

  /* ---------- Navbar scroll state ---------- */
  var $nav = $('#nav');
  function onScroll() {
    if ($(window).scrollTop() > 30) $nav.addClass('is-scrolled');
    else $nav.removeClass('is-scrolled');
  }
  $(window).on('scroll', onScroll);
  onScroll();


  /* ---------- Smooth anchor scroll ---------- */
  $('a[href^="#"]').on('click', function (e) {
    var t = $(this).attr('href');
    if (t.length < 2) return;
    var $tgt = $(t);
    if (!$tgt.length) return;
    e.preventDefault();
    $('html, body').animate({ scrollTop: $tgt.offset().top - 70 }, 700, 'swing');
  });


  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $('.reveal').addClass('is-visible');
  }


  /* ---------- Animated counters ---------- */
  function animateCounter($el, target, dur, suffix) {
    dur = dur || 1800;
    suffix = suffix || '';
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      $el.text(Math.floor(eased * target).toLocaleString('en-IN') + suffix);
      if (t < 1) requestAnimationFrame(tick);
      else $el.text(target.toLocaleString('en-IN') + suffix);
    }
    requestAnimationFrame(tick);
  }
  var countersRun = false;
  function runCounters() {
    if (countersRun) return;
    countersRun = true;
    $('.evt-stat strong[data-count]').each(function () {
      var $el = $(this);
      var target = parseInt($el.attr('data-count'), 10) || 0;
      var suffix = $el.attr('data-suffix') || '';
      animateCounter($el, target, 1800, suffix);
    });
  }
  setTimeout(runCounters, 700);


  /* ---------- Filter tabs (All Events grid) ---------- */
  $('.evt-tab').on('click', function () {
    var $btn = $(this);
    var f = $btn.attr('data-filter');
    $('.evt-tab').removeClass('is-active').attr('aria-pressed', 'false');
    $btn.addClass('is-active').attr('aria-pressed', 'true');

    var $cards = $('#evtGrid .evt-card');
    var visible = 0;

    $cards.each(function (i) {
      var $card = $(this);
      var type = $card.attr('data-type');
      var match = (f === 'all' || type === f);

      if (match) {
        visible++;
        $card.removeClass('is-hidden');
        $card.css({ opacity: 0, transform: 'translateY(14px) scale(0.98)' });
        setTimeout(function () {
          $card.css({
            opacity: 1,
            transform: 'translateY(0) scale(1)',
            transition: 'opacity .5s, transform .5s'
          });
        }, i * 45);
      } else {
        $card.css({ opacity: 0, transform: 'translateY(8px) scale(0.96)' });
        setTimeout(function () { $card.addClass('is-hidden'); }, 350);
      }
    });

    // Empty state
    if (visible === 0) $('#evtEmpty').prop('hidden', false);
    else $('#evtEmpty').prop('hidden', true);
  });


  /* ---------- Mobile nav drawer: see js/nav.js ---------- */


  /* ---------- Hero parallax (subtle) ---------- */
  $(window).on('mousemove', function (e) {
    var x = e.clientX / window.innerWidth - 0.5;
    var y = e.clientY / window.innerHeight - 0.5;
    $('.evt-hero__chakra--lg').css('transform',
      'translate(' + (x * 18) + 'px, ' + (y * 18) + 'px) rotate(' + (window.scrollY * 0.02) + 'deg)');
    $('.evt-hero__lotus').css('transform',
      'translate(calc(-50% + ' + (x * -14) + 'px), calc(-50% + ' + (y * -14) + 'px))');
  });


  /* ---------- Contact form feedback ---------- */
  $('#evtForm').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button[type="submit"] .jbtn__label');
    var orig = $btn.text();
    $btn.text('Sent ✓ — धन्यवाद');
    setTimeout(function () {
      $btn.text(orig);
      $('#evtForm')[0].reset();
    }, 2600);
  });


  /* ---------- Footer newsletter ---------- */
  $('.footer__news').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button');
    var orig = $btn.text();
    $btn.text('Thanks ✓');
    $(this).find('input').val('');
    setTimeout(function () { $btn.text(orig); }, 2400);
  });

});
